export default __webpack_public_path__ + "static/media/aboutCyberTeckAcademySmall.a976743c.png";